import React from "react";
import { PageSidebarItem } from "./PageSidebarItem";
import { ChatPreviewHoverCard } from "@/dentlab/src/components/chat/chat-preview-hover-card.component";
import { OrganizationPreviewHoverCard } from "@/dentlab/src/components/organization/organization-preview-hover-card.component";
import { PrintJobsHoverCard } from "@/dentlab/src/components/print/print-jobs-hover-card.component";
import { useRealtimeStore } from "@/lib/store/Realtime";

interface PageSidebarItemWithChatPreviewProps {
	itemKey: string;
	title: string;
	path: string;
	icon: React.ReactNode;
	expanded: boolean;
	onChatInteraction?: () => void;
	onAppInteraction?: () => void;
	onBeforeNavigate?: () => boolean;
	isLocked?: boolean;
	onLockedClick?: () => void;
	suppressHighlight?: boolean;
	badgeCount?: number;
	badgeLabel?: string;
}

export const PageSidebarItemWithChatPreview: React.FC<
	PageSidebarItemWithChatPreviewProps
> = ({
	itemKey,
	title,
	path,
	icon,
	expanded,
	onChatInteraction,
	onAppInteraction,
	onBeforeNavigate,
	isLocked,
	onLockedClick,
	suppressHighlight,
	badgeCount,
	badgeLabel,
}) => {
	const { latestChannels, userId, organization } = useRealtimeStore(
		(state) => ({
			latestChannels: state.latestChannels,
			userId: state.userId,
			organization: state.organization,
		})
	);

	if (
		itemKey === "chats" &&
		expanded &&
		latestChannels.length > 0 &&
		organization?.id &&
		userId
	) {
		return (
			<ChatPreviewHoverCard
				channels={latestChannels}
				userId={userId}
				organizationId={organization?.id}
				onChatInteraction={onChatInteraction}
			>
				{/* We need to wrap the item to avoid some error with radix accepting the children */}
				<div>
					<PageSidebarItem
						title={title}
						path={path}
						icon={icon}
						expanded={expanded}
						itemKey={itemKey}
						onInteraction={onChatInteraction}
						suppressHighlight={suppressHighlight}
					/>
				</div>
			</ChatPreviewHoverCard>
		);
	} else if (itemKey === "chats") {
		return (
			<PageSidebarItem
				title={title}
				path={path}
				icon={icon}
				expanded={expanded}
				itemKey={itemKey}
				onInteraction={onChatInteraction}
				suppressHighlight={suppressHighlight}
			/>
		);
	} else if (itemKey === "organization" && expanded) {
		return (
			<OrganizationPreviewHoverCard onAppInteraction={onAppInteraction}>
				<div>
					<PageSidebarItem
						title={title}
						path={path}
						icon={icon}
						expanded={expanded}
						itemKey={itemKey}
						onInteraction={onAppInteraction}
						onBeforeNavigate={onBeforeNavigate}
						isLocked={isLocked}
						onLockedClick={onLockedClick}
						suppressHighlight={suppressHighlight}
					/>
				</div>
			</OrganizationPreviewHoverCard>
		);
	}
	if (
		(itemKey === "org-drucker" || itemKey === "org-druckerauftraege") &&
		expanded
	) {
		return (
			<PrintJobsHoverCard onInteraction={onAppInteraction}>
				<div>
					<PageSidebarItem
						title={title}
						path={path}
						icon={icon}
						expanded={expanded}
						itemKey={itemKey}
						onInteraction={onAppInteraction}
						onBeforeNavigate={onBeforeNavigate}
						suppressHighlight={suppressHighlight}
					/>
				</div>
			</PrintJobsHoverCard>
		);
	}
	return (
		<PageSidebarItem
			title={title}
			path={path}
			icon={icon}
			expanded={expanded}
			itemKey={itemKey}
			onInteraction={onAppInteraction}
			onBeforeNavigate={onBeforeNavigate}
			isLocked={isLocked}
			onLockedClick={onLockedClick}
			suppressHighlight={suppressHighlight}
			badgeCount={badgeCount}
			badgeLabel={badgeLabel}
		/>
	);
};
